<template>  
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">
				
				<div id="response_errors" class="response_errors_container" style="display:none"></div><div>
					
					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новую версию</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать версию</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новую версию
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать версию
							</div>
						</div>
					</div>
					
					<input type="hidden" id="versionIdInput" v-model="versionId">
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Номер версии *</div>
							<input type="text" class="form-control" id="versionNumberInput" placeholder="введите номер" v-model="versionNumber">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название версии *</div>
							<input type="text" class="form-control" id="versionNameInput" placeholder="введите название" v-model="versionName">
						</div>
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание версии</div>
							<textarea name="" id="versionDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание" v-model="versionDescription"></textarea>
						</div>
					</div>
					
					<input type="hidden" id="versionClientInput" v-model="versionClientSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите клиента *</div>
							<v-select class="searchable" v-model="versionClient" 
								:options="clientOptions"
								@option:selected="onVersionClientChange($event)"
								:deselectFromDropdown="true"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="versionSoftwareInput" v-model="versionSoftwareSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите программу *</div>
							<v-select class="searchable" v-model="versionSoftware"
								:options="softwareOptions"
								@option:selected="onVersionSoftwareChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата релиза</div>
							<input type="date" class="form-control" id="versionReleaseDateInput" placeholder="Placeholder" v-model="versionReleaseDate">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата окончания техподдержки</div>
							<input type="date" class="form-control" id="versionSupportEndDateInput" placeholder="Placeholder" v-model="versionSupportEndDate">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата начала показа *</div>
							<input type="date" class="form-control" id="versionStartDateInput" placeholder="Placeholder" v-model="versionStartDate">
						</div>
					</div>					
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="versionVisibleInput" v-model="versionVisible">
								<label class="form-check-label" for="versionVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>
					
					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveVersion">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
					
				</div>
				

			</div>
		</div>	
    </div>	
</template>

<script>

export default {
    name: "CreateVersionDocumentationComponent",
	props: [
        'type',
        'element',
        'elementdetail',
		'clientlist',
		'softwarelist',
    ],
    
    data: () => {
        return {
            clientOptions: [],
            softwareOptions: [],
            versionClient: {label: ''},
            versionSoftware: {label: ''},
            versionId: '',
            versionName: '',
            versionNumber: '',
            versionDescription: '',
            versionClientSelected: '',
            versionSoftwareSelected: '',
            versionReleaseDate: '',
            versionSupportEndDate: '',
            versionStartDate: '',
            versionVisible: true,
        };
    },
	created() {

		if(this.clientlist.length > 0) {
			var list = [];
			this.clientlist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name,
				});
			});
			this.clientOptions = list;
		};
		
		if(this.softwarelist.length > 0) {
			var list = [];
			this.softwarelist.forEach(obj => {
				if(this.elementdetail.client_id) {
					if(obj.client == this.elementdetail.client_id) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}
				} else {
					list.push({
						value: obj.id,
						label: obj.name
					});
				}
			});
			this.softwareOptions = list;
		}
    },
    methods: {
        
		itemGet: async function () {
            this.versionId = this.elementdetail.id;
            this.versionName = this.elementdetail.name;
            this.versionNumber = this.elementdetail.number;
            this.versionDescription = this.elementdetail.description;
			this.versionClient = {value: this.elementdetail.client_id, label: this.elementdetail.client_name};
			this.versionClientSelected = this.elementdetail.client_id;
			this.versionSoftware = {value: this.elementdetail.sw_id, label: this.elementdetail.sw_name};
			this.versionSoftwareSelected = this.elementdetail.sw_id;
			if(this.elementdetail.release_date) {
				var releaseDate = this.elementdetail.release_date.split(' ');
				this.versionReleaseDate = releaseDate[0];
			}
			if(this.elementdetail.support_end_date) {
				var supportEndDate = this.elementdetail.support_end_date.split(' ');
				this.versionSupportEndDate = supportEndDate[0];
			}
			if(this.elementdetail.start_date) {
				var startDate = this.elementdetail.start_date.split(' ');
				this.versionStartDate = startDate[0];
			}
			this.versionVisible = (this.elementdetail.visible == 0) ? false : true;
        },

		cancel: function () {
			document.location = '/docs-edit';
		},
		
		saveVersion: function () {
			var versionData = {
				type: this.type,
				client: document.getElementById('versionClientInput').value,
				software: document.getElementById('versionSoftwareInput').value,
				number: document.getElementById('versionNumberInput').value,
				name: document.getElementById('versionNameInput').value,
				description: document.getElementById('versionDescriptionInput').value,
				release_date: document.getElementById('versionReleaseDateInput').value,
				support_end_date: document.getElementById('versionSupportEndDateInput').value,
				start_date: document.getElementById('versionStartDateInput').value,
				visible: document.getElementById('versionVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				versionData.id = document.getElementById('versionIdInput').value;
			}
			axios.post('/docs-edit/version', versionData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении версии произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},
		
		
		onVersionClientChange(events) {
			this.versionClientSelected = events.value;
			this.buildSoftwareOption();
			this.versionSoftwareSelected = '';
		},
		onVersionSoftwareChange(events) {
			this.versionSoftwareSelected = events.value;
		},
		buildSoftwareOption: function () {
			var client = this.versionClientSelected;
			if(this.softwarelist.length > 0) {
				var list = [];
				this.softwarelist.forEach(obj => {
					if(obj.client == client) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.softwareOptions = list;
				this.versionSoftware = {label: ''};
			}
		},
		
    },
    mounted() {
		this.itemGet();
    },
};
</script>
